module.exports = __webpack_public_path__ + "img/menu-state.fe0c0b90.svg";